import {styles} from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno";
import TextfieldNumber from "../textfields/textfield.number";
import React from "react";
import {ToolTipPerso} from "../selects/tooltip_perso";
import TextfieldObject from "../textfields/textfield.object";
import TextfieldExemplaire from "../textfields/textfield.exemplaire";

const NOM_SIGNATAIRE_MAX_LENGTH = 100;
const ADRESSE_SIGNATAIRE_MAX_LENGTH = 160;

const limitSignataireValue = (value, maxLength) => {
    return value
        .replace(/\r/g, "")
        .split("\n")
        .slice(0, 2)
        .join("\n")
        .substring(0, maxLength);
};

    // Cas général d'utilisation :

    // <ConventionHonoraires
    //           handleChange={genericHandleChange}
    //           conventionHonoraires={props.conventionHonoraires}
    //           setConventionHonoraires={props.setConventionHonoraires}
    //           nombreConventionHonoraires={props.nombreConventionHonoraires}
    //           setNombreConventionHonoraires={props.setNombreConventionHonoraires}
    //           objectConventionHonoraires={props.objectConventionHonoraires}
    //           setObjectConventionHonoraires={props.setObjectConventionHonoraires}
    //           montantConventionHonoraires={props.montantConventionHonoraires}
    //           setMontantConventionHonoraires={props.setMontantConventionHonoraires}
    //         />

const ConventionHonoraires = (props) => {
    const isVisible = props.simulateur_116 || parseInt(props.conventionHonoraires) === 1;

    return (
        <>
            {!props.simulateur_116 && (
                <div className="cardRow">
                    <div className="badge-hover-parent" style={{...styles.cardElemVerticalyCenter, display: 'flex', alignItems: 'center', flexWrap: 'wrap', whiteSpace: 'normal', gap: '8px', minWidth: 0}}>
                        Souhaitez-vous joindre une convention d'honoraires ?
                        <ToolTipPerso 
                            title={
                                "Selon les articles L.444-1 et R444-16 du Code de commerce et l'Annexe 4-9 du même Code"
                            }
                        />
                    </div>
                    <div>
                        <ButtonYesno handleChange={props.handleChange} setter={props.setConventionHonoraires} defaultValue={props.conventionHonoraires}/>
                    </div>
                </div>
            )}

            {isVisible && (
                <>
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>Combien d'exemplaires ? :</div>
                        <TextfieldExemplaire
                            placeholder={"Indiquer le nombre d'exemplaires"}
                            setter={props.setNombreConventionHonoraires}
                            value={props.nombreConventionHonoraires}
                        />
                    </div>
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>Indiquer son objet :</div>
                        <TextfieldObject
                            handleChange={props.handleChange}
                            type={"text"}
                            placeholder={"Indiquer l'objet de la convention"}
                            setter={props.setObjectConventionHonoraires}
                            value={props.objectConventionHonoraires}
                        />
                    </div>
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>Indiquer son montant HT :</div>
                        <TextfieldNumber
                            handleChange={props.handleChange}
                            type={"number"}
                            placeholder={"Indiquer le montant de la convention"}
                            setter={props.setMontantConventionHonoraires}
                            value={props.montantConventionHonoraires}
                        />
                    </div>
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>Nom et prénom ou dénomination de la société :</div>
                        <textarea
                            style={{ fontFamily: "roboto", overflow: "hidden", resize: "none" }}
                            className={"input_field"}
                            placeholder={"Indiquer le nom du signataire"}
                            value={props.nomSignataireConventionHonoraires || ""}
                            onChange={(e) => props.handleChange(props.setNomSignataireConventionHonoraires, limitSignataireValue(e.target.value, NOM_SIGNATAIRE_MAX_LENGTH))}
                            maxLength={NOM_SIGNATAIRE_MAX_LENGTH}
                            rows={2}
                            cols={50}
                        />
                    </div>
                    <div className="cardRow">
                        <div style={styles.cardElemVerticalyCenter}>Adresse du signataire :</div>
                        <textarea
                            style={{ fontFamily: "roboto", overflow: "hidden", resize: "none" }}
                            className={"input_field"}
                            placeholder={"Indiquer l'adresse du signataire"}
                            value={props.adresseSignataireConventionHonoraires || ""}
                            onChange={(e) => props.handleChange(props.setAdresseSignataireConventionHonoraires, limitSignataireValue(e.target.value, ADRESSE_SIGNATAIRE_MAX_LENGTH))}
                            maxLength={ADRESSE_SIGNATAIRE_MAX_LENGTH}
                            rows={2}
                            cols={50}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default ConventionHonoraires;